import { getShareMedia } from '@blueberry/config/site';

export const types = {
  CHANGE_SOCIAL: 'CHANGE_SOCIAL',
};

export const actions = {
  changeSocial: region => ({
    type: types.CHANGE_SOCIAL,
    payload: {
      region,
    },
  }),
};

const initialState = {
  socials: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_SOCIAL: {
      const socials = getShareMedia(action.payload.region);

      return {
        ...state,
        ...socials,
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getSocials = state => state.socialMedia.socials;



// WEBPACK FOOTER //
// ./app/redux/socialMedia.js